import { getIconProps, type IconProps } from '#types'

/**
 * Included icon — checkmark inside a rounded starburst / badge shape.
 *
 * Used for feature lists, included items, and plan benefits.
 *
 * @example
 * ```tsx
 * <li>
 *   <IncludedIcon className="h-5 w-5" /> Up to 60 hours per month
 * </li>
 * ```
 */
export function IncludedIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M15.2722 10.3636L11.1813 14.4546L9.54492 12.8182"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5198 3.73524C11.2631 2.75492 12.7369 2.75492 13.4802 3.73524L14.4086 4.9596C14.6114 5.22705 14.9427 5.36428 15.2752 5.31856L16.7974 5.10927C18.0162 4.94169 19.0583 5.98379 18.8907 7.2026L18.6814 8.7248C18.6357 9.05732 18.773 9.38863 19.0404 9.59142L20.2648 10.5198C21.2451 11.2631 21.2451 12.7369 20.2648 13.4802L19.0404 14.4086C18.773 14.6114 18.6357 14.9427 18.6814 15.2752L18.8907 16.7974C19.0583 18.0162 18.0162 19.0583 16.7974 18.8907L15.2752 18.6814C14.9427 18.6357 14.6114 18.773 14.4086 19.0404L13.4802 20.2648C12.7369 21.2451 11.2631 21.2451 10.5198 20.2648L9.59142 19.0404C9.38863 18.773 9.05732 18.6357 8.7248 18.6814L7.2026 18.8907C5.98379 19.0583 4.94169 18.0162 5.10927 16.7974L5.31856 15.2752C5.36428 14.9427 5.22705 14.6114 4.9596 14.4086L3.73524 13.4802C2.75492 12.7369 2.75492 11.2631 3.73524 10.5198L4.9596 9.59142C5.22705 9.38863 5.36428 9.05732 5.31856 8.7248L5.10927 7.2026C4.94169 5.98379 5.98379 4.94169 7.2026 5.10927L8.7248 5.31856C9.05732 5.36428 9.38863 5.22705 9.59142 4.9596L10.5198 3.73524Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}
